import { Battery, Zap } from "lucide-react";

interface ProductHeroProps {
  activeCategory: "consumer" | "power";
  onCategorySwitch: (category: "consumer" | "power") => void;
  isVisible: boolean;
}

export default function ProductHero({
  activeCategory,
  onCategorySwitch,
  isVisible,
}: ProductHeroProps) {
  return (
    // <section
    //   className={`relative bg-gradient-to-r from-stone-800 via-stone-800/95 to-stone-900/95 py-12 transition-all duration-700 ${
    //     isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
    //   }`}
    // > 
    <section
      className={`relative bg-gradient-to-r from-stone-800 via-stone-800/95 to-stone-900/95 py-12 transition-all duration-700 ${
        isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
      }`}
    >
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat opacity-20"
        style={{
          backgroundImage: "url('/Products/productshero.png')",
        }}
      />

      <div className="max-w-7xl mx-auto px-6 mt-12 relative z-10">
        <div className="text-center text-white">
          <h1 className="text-5xl font-light mb-6 tracking-tight">Products</h1>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto mb-8 leading-relaxed">
            Wide-ranging development capabilities, comprehensive service
            solutions
          </p>

          <div className="inline-flex bg-white/10 backdrop-blur-sm rounded-2xl p-2 border border-white/20">
            <button
              onClick={() => onCategorySwitch("consumer")}
              className={`px-8 py-4 rounded-xl transition-all duration-300 flex items-center gap-3 ${
                activeCategory === "consumer"
                  ? "bg-white text-gray-900 shadow-lg"
                  : "text-white/80 hover:text-white hover:bg-white/10"
              }`}
            >
              <Battery className="w-5 h-5" />
              Consumer Battery
            </button>
            <button
              onClick={() => onCategorySwitch("power")}
              className={`px-8 py-4 rounded-xl transition-all duration-300 flex items-center gap-3 ${
                activeCategory === "power"
                  ? "bg-white text-gray-900 shadow-lg"
                  : "text-white/80 hover:text-white hover:bg-white/10"
              }`}
            >
              <Zap className="w-5 h-5" />
              Power Battery
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
